import { Frame, Img } from "./DeckShell";

/* «What it is» — slide 02 i alle deck: manifestet som definerer produktet før vi selger posisjonen. Venstre: tese, definisjon og tre
   søyler på papir. Høyre: salen sett fra scenen — 700 ansikter (konseptvisualisering, merket) i full høyde ut til kanten, med avgrensningen i hvitt over bildet. */
const PILLARS = [
  ["Leadership", "World-class speakers — and the people making the decisions."],
  ["Building", "Live demonstrations of what can actually be built with AI."],
  ["Impact", "Real conversations about business, productivity, policy and society."],
];

export const WhatItIs = ({ nr, mottaker }) => (
  <Frame nr={nr} label="What it is" mottaker={mottaker} className="hd-what hd-light">
    <h2 className="hd-what-h" data-testid="hd-what-h">Where Norway goes<br />from AI ambition<br />to AI action.</h2>
    <p className="hd-what-lead" data-testid="hd-what-lead"><b>Norwegian AI Summit</b> brings together 700 of Norway's decision-makers, builders, investors and policymakers for one focused day in Bergen.</p>
    <ol className="hd-what-pillars" data-testid="hd-what-pillars">
      {PILLARS.map(([t, d], i) => (
        <li key={t}><span className="k">0{i + 1}</span><h3>{t}</h3><p>{d}</p></li>
      ))}
    </ol>
    <p className="hd-what-line" data-testid="hd-what-line">13 April 2027<i>·</i>Grieghallen, Bergen<i>·</i>700 seats, invitation-led<i>·</i>Proposed opening keynote: Kevin O'Leary</p>
    <figure className="hd-what-photo" data-testid="hd-what-photo">
      <Img src="/images/what-room-v4.webp" alt="" draggable={false} fetchPriority="high" />
      <span className="cap">The room · concept visualisation</span>
      <p className="not" data-testid="hd-what-not">Not a trade show.<br />Not a sales stage.<br /><b>One room. One programme.<br />The people shaping Norway's AI future.</b></p>
    </figure>
  </Frame>
);
